export default function Footer() {
    return (
        <div style={{ backgroundColor: "#4668a0" }}>
            <footer className="container py-4 mt-5">
                <div className='row text-light'>
                    <div className='col-lg-8 col-xs-9 text-start'>
                        <p>© Copyright {new Date().getFullYear()}</p>
                    </div>
                    <div className="col-lg-4 col-xs-3 text-end">
                        <p> Managed by Freese and Nichols Inc.</p>
                    </div>
                </div>
            </footer>
        </div>
    )
}